import { SelectLang } from '../SelectLang';
import styles from './PublicHeader.module.css';

export const PublicHeader = () => {
  return (
    <div className={styles.container}>
      <img src="/img/main-logo.png" height={24} width={129.3} alt="" />

      <SelectLang />
    </div>
  );
};
